import Form from './Form';
import 'form-serializer';
import 'jquery-validation';

class RequestInformationForm extends Form {
  setupDefaults() {
    super.setupDefaults();
    this.endpoint = this.$el.attr('action');
    this.initialData = {};
    this.step = 0;
    this.dom = {
      ...this.dom,
      $submitBtn: this.$el.find('input[type="submit"]'),
      $sourceInput: this.$el.find('input[name="source"]')[0],
      $mediumInput: this.$el.find('input[name="medium"]')[0],
      $campaignInput: this.$el.find('input[name="campaign"]')[0],
      $phoneInput: this.$el.find('input[name="phone"]')[0],
      $nextStepButton: this.$el.find('.form-offer_form-next-step')
    };

    this.setupHiddenFields();

    if (this.$el.parents('.form-offer-ri').length > 0) {
      this.$el.find('.callout-field:nth-child(5)')[0].style.display = 'block';
    }
    this.$el.validate().settings.ignore = [];
  }

  addListeners() {
    this.$el.on('submit', :: this.onFormSubmit);
    this.dom.$nextStepButton.on('click', :: this.moveToStep);
  }

  onFormSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    if (this.$el.valid()) {
      this.submitForm();
    }
  }

  async submitForm() {
    this.dom.$submitBtn.attr('disabled', 'disabled').parent().addClass('is-loading');
    this.clearFormLevelError();

    this.initialData = JSON.parse(this.$el.serializeJSON());
    this.initialData.phone = this.dom.$phoneInput.dataset.maskRawValue;

    const res = await this.postData(this.initialData);

    if (res.success) {
      const redirectURL = res.response.redirectUrl;
      window.location.replace(redirectURL);
    } else {
      this.clearFormLevelError();
      if (this.dom.$nextStepButton !== null) {
        this.displayFormLevelErrorFourStep(res.message);
      } else {
        this.displayFormLevelError(res.message);
      }

      this.dom.$submitBtn.removeAttr('disabled').parent().removeClass('is-loading');
    }
  }

  postData(data) {
    return $.ajax({
      method: 'POST',
      url: this.endpoint,
      contentType: 'application/json',
      data: JSON.stringify(data)
    });
  }

  //The code below was taken from the BizMtkg APM implementation

  setupHiddenFields() {

    if (typeof this.crumbleCookie()['FirstSession'] === 'undefined') {
      this.writeLogic('FirstSession');
    }

    const session = this.crumbleCookie()['FirstSession'];

    this.dom.$sourceInput.value = this.getParam(unescape(`?${session}`), 'source');
    this.dom.$mediumInput.value = this.getParam(unescape(`?${session}`), 'medium');
    this.dom.$campaignInput.value = this.getParam(unescape(`?${session}`), 'campaign');
  }

  crumbleCookie(a) {
    const c = {};
    for(let d = document.cookie.split(';'), b = 0; b < d.length; b++) {
      const e = d[b].substring(0, d[b].indexOf('=')).trim();
      const i = d[b].substring(d[b].indexOf('=') + 1, d[b].length).trim();
      c[e] = i
    }
    if (a) return c[a] ? c[a] : null;
    return c
  }

  bakeCookie(a, d, c, b, e, i) {
    let j = new Date;
    j.setTime(j.getTime());
    j = new Date(j.getTime() + c);
    document.cookie = `${a}=${escape(d)}${c ? `;expires=${j.toGMTString()}` : ''}${b ? `;path=${b}` : ''}${e ? `;domain=${e}` : ''}${i ? ';secure' : ''}`
  }

  getParam(s, q) {
    try {
      const match = s.match(`[?&]${q}=([^&]+)`);
      return match ? match[1] : '';
    } catch (e) {
      return '';
    }
  }

  calculateTrafficSource() {
    let source = '', medium = '', campaign = '', term = '', content = '', gclid = '', ref = document.referrer;
    const search_engines = [['bing', 'q'], ['google', 'q'], ['yahoo', 'q'], ['baidu', 'q'], ['yandex', 'q'], ['ask', 'q']]; //List of search engines
    ref = ref.substr(ref.indexOf('//') + 2);
    const ref_domain = ref;
    const ref_path = '/';
    const ref_search = '';

    // Checks for campaign parameters
    const url_search = document.location.search;

    if (url_search.indexOf('utm_source') > -1) {
      source = this.getParam(url_search, 'utm_source');
      medium = this.getParam(url_search, 'utm_medium');
      campaign = this.getParam(url_search, 'utm_campaign');
      term = this.getParam(url_search, 'utm_term');
      content = this.getParam(url_search, 'utm_content');
      gclid = '(not set)';
    } else if (this.getParam(url_search, 'gclid')) {
      source = 'google';
      medium = 'cpc';
      campaign = '(not set)';
      gclid = this.getParam(url_search, 'gclid');
    } else if (ref) {

      // separate domain, path and query parameters
      if (ref.indexOf('/') > -1) {
        const ref_domain = ref.substr(0, ref.indexOf('/'));
        let ref_path = ref.substr(ref.indexOf('/'));
        if (ref_path.indexOf('?') > -1) {
          const ref_search = ref_path.substr(ref_path.indexOf('?') + 1);
          ref_path = ref_path.substr(0, ref_path.indexOf('?'));
        }
      }
      medium = 'referral';
      source = ref_domain;
      // Extract term for organic source
      for(let i = 0; i < search_engines.length; i++) {
        if (ref_domain.indexOf(search_engines[i][0]) > -1) {
          medium = 'organic';
          source = search_engines[i][0];
          term = this.getParam(ref_search, search_engines[i][1]) || '(not provided)';
          break;
        }
      }
    }

    return {
      source,
      medium,
      campaign,
      gclid,
      term,
      content
    };
  }

  getTrafficSource(cookieName) {
    const trafficSources = this.calculateTrafficSource();
    const source = trafficSources.source.length === 0 ? 'direct' : trafficSources.source;
    const medium = trafficSources.medium.length === 0 ? 'none' : trafficSources.medium;
    let campaign = trafficSources.campaign.length === 0 ? 'direct' : trafficSources.campaign;
    // exception
    if (medium === 'referral') {
      campaign = '';
    }
    const rightNow = new Date();
    const value = `source=${source}&medium=${medium}&campaign=${campaign}&gclid=${trafficSources.gclid}&term=${trafficSources.term}&content=${trafficSources.content}&date=${rightNow.toISOString().slice(0, 10).replace(/-/g, '')}`;

    return value;
  }

  writeLogic(n) {
    let a = this.getTrafficSource(n);

    a = a.replace(/\|{2,}/g, '|');
    a = a.replace(/^\|/, '');
    a = unescape(a);

    this.bakeCookie(n, a, 1000 * 60 * 30, '/', '', '');
  }


  moveToStep() {
    const inputs = Array.from(this.$el.find('.form-offer__form .callout-field'));
    const elementsToValidate = this.$el.find('input:visible');
    const validator = this.$el.validate();
    let stepIsValid = true;
    $.each(elementsToValidate, (key, value) => {
      if (!validator.element(value)) {
        stepIsValid = false;
        validator.showErrors();
      }
    });
    if (stepIsValid) {
      inputs.forEach(e => { e.style.display = 'none'; });
      const formParent = this.$el.parents('.form-offer-ri');
      switch (this.step) {
      case 0:
        this.$el.find('.form-offer__form .callout-field:nth-child(3)')[0].style.display = 'block';
        this.step = 1;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-2');
        this.$el.find('.form-offer_form-next-step')[0].innerHTML = formParent.data('step-2Button');
        break;
      case 1:
        this.$el.find('.form-offer__form .callout-field:nth-child(1)')[0].style.display = 'block';
        this.$el.find('.form-offer__form .callout-field:nth-child(2)')[0].style.display = 'block';
        this.step = 2;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-3');
        this.$el.find('.form-offer_form-next-step')[0].innerHTML = formParent.data('step-3Button');
        break;
      case 2:
        this.$el.find('.form-offer__form .callout-field:nth-child(4)')[0].style.display = 'block';
        this.$el.find('.form-offer__form .callout-field:nth-child(6)')[0].style.display = 'block';//breed
        this.$el.find('.form-offer__form .callout-field:nth-child(7)')[0].style.display = 'block';//comments
        this.$el.find('.form-offer__form .form-offer__form-disclaimer')[0].style.display = 'block';//checkbox
        this.$el.find('.form-offer__form .form__submit')[0].style.display = 'block';
        this.$el.find('.form-offer_form-next-step')[0].style.display = 'none';
        this.step = 3;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-4');
        break;
      }
    }
  }
  displayFormLevelErrorFourStep(errorMessage) {
    let errorMessages = [];
    if (errorMessage.indexOf('~') !== -1) {
      errorMessages = errorMessage.split('~');
    } else {
      errorMessages.push(errorMessage);
    }
    if (typeof this.dom.$formLevelErrorContainer === 'undefined' || this.dom.$formLevelErrorContainer.length === 0) {
      const fourStepSubmitButton = this.$el.find('.form__submit.is-loading');
      $('<div class="form__global-error"></div>').insertBefore(fourStepSubmitButton);
      errorMessages.forEach(errorMsg => {
        this.dom.$formLevelErrorContainer = fourStepSubmitButton.prev('.form__global-error').append(`<p>${errorMsg}</p>`);
      });
    } else {
      errorMessages.forEach(errorMsg => {
        this.dom.$formLevelErrorContainer.append(`<p>${errorMsg}</p>`);
      });
    }
  }
}

export default RequestInformationForm;



// WEBPACK FOOTER //
// ./src/apm/js/components/RequestInformationForm.js